import React from 'react';
import Modal from 'react-modal';
import { fetchQuestionsCategory, DeleteCategory } from '../api/api';
import PageNavigation from './PageNavigation';
import LoaderComponent from './LoaderComponent';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../App.css';

const customStyles = {
    overlay: {
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.4)'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10000
    }
};

export class QuestionsCategorylist extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Questions: [],
            showPopup: false,
            isLoading: false,
            openCategoryIds: [],

        }
    }

    async componentDidMount() {
        this.setState({ isLoading: true });
        await fetchQuestionsCategory();
        this.setState({
            Questions: this.props.questionscategoryList,
            isLoading: false
        })
    }

    deleteHandler = async () => {
        const { btnActionId } = this.state;
        this.setState({ isLoading: true });
        try {
            const result = await DeleteCategory(btnActionId);

            if (result && result.message) {
                toast.success(`${result.message}`, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
                await fetchQuestionsCategory();
                this.setState({
                    Questions: this.props.questionscategoryList,
                    isLoading: false
                });
            } else {
                toast.info(`${result?.message || 'Delete failed'}`, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
                this.setState({ isLoading: false });
            }
            this.setState({
                showPOPUP: false,
                categoryAction: "",
                btnActionId: ""
            })
        } catch (error) {
            this.setState({ isLoading: false });
            toast.error('Unable to delete category. Please try again.');
        }
    }

    toggleCategory = (id) => {
        this.setState(prevState => {
            const isOpen = prevState.openCategoryIds.includes(id);
            return {
                openCategoryIds: isOpen
                    ? prevState.openCategoryIds.filter(item => item !== id)
                    : [...prevState.openCategoryIds, id]
            };
        });
    }

    handleShowAlert = (item) => {
        
        this.setState({
            showPOPUP: true,
            btnActionId: item.id,
            categoryAction: item.title,
            openCategoryIds: []
        })
    }

    handleClose = () => {
        this.setState({
            showPOPUP: false,
            categoryAction: "",
            btnActionId: ""
        })
    }

    display = () => {
        const categories = this.props.questionscategoryList.response || [];
        return categories.map((data, id) => {
            const hasChildren = this.state.showPopup ? false : Array.isArray(data.children) && data.children.length > 0;
            let isOpen = this.state.openCategoryIds.includes(data.id);
            
            return (
                <li key={id} className="list-group-item category-group">
                    <div
                        className={`category-main${hasChildren ? ' has-sub' : ''}`}
                        onClick={() => hasChildren && this.toggleCategory(data.id)}
                    >
                        <span className={`category-title${hasChildren ? ' has-sub' : ''}${isOpen ? ' open' : ''}`}>
                            {data.title}
                        </span>
                        <button
                            className="btn btn-sm btn-light text-danger category-action-btn"
                            type="button"
                            title="Delete category"
                            onClick={(event) => { event.stopPropagation(); this.handleShowAlert(data); }}
                        >
                            Delete
                        </button>
                    </div>
                    {hasChildren && (
                        <ul className={`subcategories${isOpen ? ' open' : ''}`}>
                            {data.children.map((child, i) => (
                                <li key={i} className="list-group-item category-sub">
                                    <span>{child.title}</span>
                                    <button
                                        className="btn btn-sm btn-outline-danger category-action-btn"
                                        type="button"
                                        title="Delete subcategory"
                                        onClick={(event) => { event.stopPropagation(); this.handleShowAlert(child); }}
                                    >
                                        Delete
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </li>
            );
        });
    }
    render() {
        const { isLoading, categoryAction, showPOPUP } = this.state;
        return (
            <div className="container-fluid">
                <PageNavigation {...this.props} header="List of Sections" path="/admin/configure" category={null} parentId={null} />
                <LoaderComponent isLoading={isLoading} />
                <ul className="list-group category-list">
                    {this.display()}
                </ul>

                <Modal
                    isOpen={showPOPUP}
                    onRequestClose={this.handleClose}
                    style={customStyles}
                    contentLabel="Forgot Password"
                    ariaHideApp={false}
                >
                    <h4 className="text-primary">Are you sure to delete this Section? </h4>{categoryAction}
                    <div className="form-group row d-flex justify-content-center">

                    </div>
                    <div className="row ">
                        <div className="col-6 text-center ">
                            <button className="button-pop" onClick={this.deleteHandler} >Yes</button>

                        </div>
                        <div className="col-6 text-center ">
                            <button className="button-pop" onClick={this.handleClose} >No</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        questionscategoryList: state.categoryList.questionscategoryList,
    }
}
export default connect(mapStateToProps)(QuestionsCategorylist);